import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, MapPin, Calendar, Check, ArrowRight } from 'lucide-react';
import { SERVICES, IMAGES } from '../mock';
import { fetchServices } from '../api';

const Services = () => {
  const [services, setServices] = useState(SERVICES);
  useEffect(() => {
    fetchServices()
      .then((data) => {
        if (Array.isArray(data) && data.length) {
          setServices(data.filter((s) => s.active !== false).map((s) => ({
            ...s,
            duration: s.durationMin ? `${s.durationMin} min` : s.duration,
            booking: s.bookingLabel || s.booking || 'Book Now',
          })));
        }
      })
      .catch(() => {}); // keep mock.js fallback
  }, []);

  return (
    <div className="pt-28 pb-24 min-h-screen">
      {/* Hero */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.crystals} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0708] via-[#0a0708]/85 to-[#0a0708]" />
        </div>
        <div className="relative max-w-3xl mx-auto px-5 text-center">
          <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-4">Cleanse · Balance · Restore</p>
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient leading-tight">Healing & Services</h1>
          <div className="gold-divider my-6" />
          <p className="font-cormorant text-xl md:text-2xl text-[#f5ecd9]/75 leading-relaxed">Spiritual baths, chakra work, tarot & oracle readings, guided yoga, meditation and guided journeys — led by experienced practitioners to help you find balance and inner peace. All in-person sessions are conducted face-to-face.</p>
        </div>
      </section>

      {/* Services list */}
      <section className="max-w-6xl mx-auto px-5 py-10">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((s) => (
            <div key={s.id} className="card-glass rounded-2xl overflow-hidden hover-lift flex flex-col">
              <div className="aspect-[16/9] overflow-hidden bg-[#120d10]"><img src={s.image} alt={s.name} loading="lazy" className="w-full h-full object-cover" /></div>
              <div className="p-7 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-cinzel text-2xl text-[#f5ecd9]">{s.name}</h3>
                  <span className="font-cinzel text-xl text-gold-gradient whitespace-nowrap">{s.priceLabel}</span>
                </div>
                <div className="flex items-center gap-4 mt-2 text-xs text-[#f5ecd9]/50 font-jost">
                  <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-[#f0d582]" /> {s.duration}</span>
                  <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-[#f0d582]" /> In person</span>
                </div>
                <p className="font-jost text-sm text-[#f5ecd9]/70 leading-relaxed mt-4 flex-1">{s.summary}</p>
                {s.includes && (
                  <ul className="mt-4 space-y-1.5">
                    {s.includes.map((inc) => (<li key={inc} className="flex items-center gap-2 text-xs text-[#f5ecd9]/60 font-jost"><Check className="h-3.5 w-3.5 text-[#ff4da6]" /> {inc}</li>))}
                  </ul>
                )}
                {s.variants && (
                  <div className="mt-4 flex flex-wrap gap-2">
                    {s.variants.map((v) => (
                      <span key={v.key} className="inline-flex items-center gap-1.5 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/5 px-3 py-1.5 text-xs font-jost text-[#f5ecd9]/80">{v.label} <span className="text-[#f0d582]">{v.priceLabel}</span></span>
                    ))}
                  </div>
                )}
                <Link to={`/book?service=${s.id}`} className="btn-gold inline-flex items-center justify-center gap-2 mt-6 rounded-full py-3 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]"><Calendar className="h-4 w-4" /> {s.booking || 'Book Now'}</Link>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center font-jost text-xs text-[#f5ecd9]/40 mt-10 max-w-2xl mx-auto">Service descriptions shown are neutral summaries. Detailed session descriptions, what's included and preparation notes can be added with your final copy.</p>
      </section>

      <section className="max-w-4xl mx-auto px-5 text-center">
        <div className="card-glass rounded-3xl p-12">
          <h2 className="font-cinzel text-3xl text-gold-gradient">Ready to restore your balance?</h2>
          <p className="font-cormorant text-xl text-[#f5ecd9]/70 mt-3 mb-8">Choose a service and request your appointment in a few taps.</p>
          <Link to="/book" className="btn-gold inline-flex items-center gap-2 rounded-full px-9 py-4 text-sm font-semibold text-[#0a0708] bg-gradient-to-r from-[#d4af37] via-[#f0d582] to-[#d4af37]">Book Appointment <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
